export default __webpack_public_path__ + "9506c7f0751fcd342a89d85c1ea91b4a.png";